<template>
    <tr>
        <td :colspan class="italic">{{ $t("Notifications.AddAlertMessage") }}</td>
        <td class="text-right">
            <Button variant="primary" size="icon" class="md:hidden" @click.stop="addAlert()">
                <Icon name="plus" />
            </Button>
            <Button variant="primary" size="sm" class="hidden md:inline-block" @click.stop="addAlert()">
                <Icon name="plus" />
                <span>{{ $t("Global.Add") }}</span>
            </Button>
        </td>
    </tr>
</template>

<script setup lang="ts">
const model = defineModel<PriceAlert | null>();
const { colspan } = defineProps<{ colspan: string }>();

function addAlert() {
    model.value = {
        Id: 0,
        Quantity: 0,
        NotificationId: 0,
        Amount: 0,
        Modifier: MODIFIER_TYPE.GREATER_THAN,
        Status: AlertStatus.Enabled,
    };
}
</script>
